import { ClaimStatus } from 'app/claims/models/claim-status.enum';

export const ClaimsConfig = {
    defaultTabIndex: 3,
    finalizedClaimStatuses: [
        ClaimStatus.CLOSED,
        ClaimStatus.DENIED,
        ClaimStatus.DRAFT_DISCARDED,
        ClaimStatus.MISSING_SHIPMENT,
        ClaimStatus.PAYMENT_PAID,
        ClaimStatus.WITHDRAWN,
    ],
    erroneousClaimStatuses: [
        ClaimStatus.INVALID_CARRIER,
        ClaimStatus.INVALID_INSURED_VALUE,
        ClaimStatus.INVALID_SHIP_DATE,
        ClaimStatus.MISSING_SHIPMENT,
        // ClaimStatus.SUBMIT_ERROR,
    ],
    stepperOrientationThreshold: 10,
    supportEmail: 'parcelproclaims@ups.com',
};
